import {
  Injectable,
  Injector,
  TemplateRef,
  WritableSignal,
  isSignal,
  signal,
} from '@angular/core';

export interface TopNavSlot {
  template: TemplateRef<any>;
  injector: Injector;
}

@Injectable({
  providedIn: 'root',
})
export class TopNavigationSlotsService {
  readonly startSlot = signal<TopNavSlot>(null);
  readonly endSlot = signal<TopNavSlot>(null);

  setSlot(
    slot: 'start' | 'end',
    template: TemplateRef<any> = null,
    injector: Injector = null,
  ) {
    const propKey = `${slot}Slot`;

    if (!(propKey in this) || !isSignal(this[propKey])) {
      return;
    }

    if (template == null) {
      (this[propKey] as WritableSignal<TopNavSlot>).set(null);
      return;
    }

    (this[propKey] as WritableSignal<TopNavSlot>).set({
      template,
      injector,
    });
  }
}
